export type AuthPromptReason = "insecure-no-token" | "auth-failed";

/**
 * Returns true when the browser is in an insecure context (plain HTTP)
 * and has no stored gateway token — meaning the user must provide one
 * before a WebSocket connection can succeed.
 */
export function needsTokenPrompt(
  settings: { token: string },
  isSecureContext: boolean,
): boolean {
  if (isSecureContext) return false;
  return !settings.token.trim();
}

const AUTH_CLOSE_PATTERNS = [
  "device identity required",
  "unauthorized",
  "secure context",
  "connect failed",
];

/**
 * Returns true when a WebSocket close event indicates an authentication
 * failure that a token prompt could resolve.
 */
export function isAuthCloseEvent(code: number, reason: string): boolean {
  if (code === 1012) return false;
  if (code !== 1008 && code !== 4008) return false;
  const lower = reason.toLowerCase();
  return AUTH_CLOSE_PATTERNS.some((pattern) => lower.includes(pattern));
}

/**
 * Wraps `window.isSecureContext` with a safe fallback for SSR / non-browser.
 */
export function resolveIsSecureContext(): boolean {
  return typeof window !== "undefined" ? window.isSecureContext : true;
}
